import { FlowTextBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const TextBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Text),
  config: FlowTextBlockConfigSchema,
});

export type TextBlock = z.infer<typeof TextBlockSchema>;
